import { InjectionToken } from '@angular/core';

export const PFE_GUARDS_CONFIG = new InjectionToken<Record<string | number | symbol, () => boolean>>('PFE_GUARDS_CONFIG');

/**
 * NavigationBehaviorOptions.state property.
 * If set to true, navigation will bypass PFE routing actions.
 */
export const BYPASS_PFE_ROUTING = 'BYPASS_PFE_ROUTING';
